import { useMutation, useQuery } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, OAuth2BridgeRequest, OAuth2BridgeResponse, OAuth2StatusResponse } from '../types/showcase';

/**
 * GET /api/eraf/showcase/demo/oauth2/status — C035 OAuth2/OIDC 브릿지 status 조회
 * queryKey: ['common-showcase', 'oauth2', 'status']
 */
export function useOAuth2Status() {
  return useQuery<OAuth2StatusResponse, ApiError>({
    queryKey: ['common-showcase', 'oauth2', 'status'],
    queryFn: () => showcaseApi.oauth2Status(),
    staleTime: 15_000,
  });
}

/**
 * POST /api/eraf/showcase/demo/oauth2/bridge — 서버간 OIDC(RS256)→eraf HS384 브리지 왕복
 * mutationKey: ['common-showcase', 'oauth2', 'bridge']
 */
export function useOAuth2Bridge() {
  return useMutation<OAuth2BridgeResponse, ApiError, OAuth2BridgeRequest>({
    mutationFn: (req) => showcaseApi.oauth2Bridge(req),
    mutationKey: ['common-showcase', 'oauth2', 'bridge'],
  });
}
